import { Request } from "../components/Request";
import '../components/SiteLinker.jsx';
import { assignPage } from 'navigation/pageLocation';
import { initializeBugWorkspaces } from 'app/bugWorkspaceActions';
import { clearInlineError, showInlineError } from 'components/inlineFeedback';

export default class Bugs {
	static dynamicActivated = false;

	static activateDynamicBugClosing() {
		initializeBugWorkspaces();
		if(Bugs.dynamicActivated) {
			return;
		}
		Bugs.dynamicActivated = true;
		$(document).on('change', '.bug_list input[type=checkbox]', function(e) {
			var checkbox = $(this);
			var row = checkbox.closest('.bug_row');
			var container = checkbox.closest('div');
			var bugId = checkbox.closest('.bug_row').data('bug_id');
			var value = checkbox.is(':checked') ? 1 : 0;
			var checkboxName = checkbox.attr('name');
			var statusButton = row.find('.status button');

			statusButton = statusButton.add(container.find('.fix'));
			let closeReportOptions = container.find('.close_report_options');

			container.addClass('spinner');
			clearInlineError(container);
			var data = {
				bug_id: bugId
			};
			data[checkboxName] = value;
			var isChangingStatus = function() {
				return checkboxName == 'fixed';
			};
			if(isChangingStatus()) {
				statusButton.prop('disabled', true);
			}
			$.post(siteUrl + '/bugs/update_bug', data, function(response) {
				container.removeClass('spinner');
				if(isChangingStatus()) {
					statusButton.prop('disabled', false);
				}
				if(response.bug) {
					if(response.bug.fixed) {
						row.find('.status').removeClass('open').addClass('closed');
						closeReportOptions.addClass('is_fixed');
					}
					else {
						row.find('.status').addClass('open').removeClass('closed');
						closeReportOptions.removeClass('is_fixed');
					}
				}
			}).error(function() {
				container.removeClass('spinner');
				if(isChangingStatus()) {
					statusButton.prop('disabled', false);
				}
				showInlineError(container, 'The bug could not be updated.');
			});
		}).on('click', '.status', function() {
			$(this).closest('.bug_row').find('.fixed').find('input').trigger('click');
		}).on('change', '.infraction_update_items form .input-toggle input', function() {
			let form = $(this).closest('form');
			let button = $(this);
			let data = form.serializeArray();
			button.prop('disabled', true);
			let finished = function() {
				button.prop('disabled', false);
			};
			$.post(form.attr('action'), data, function(response) {
				updateInfractionState(response.infraction);
				finished();
			});
		});
		let updateInfractionState = function(infractionData) {
			if(!infractionData) {
				return;
			}
			let infraction = $('.infraction_summary_' + infractionData.id);
			infraction.find('.infraction_update_items .infraction_visibility')
				.toggleClass('active', infractionData.player_can_see);
			infraction.add(infraction.find('.infraction_update_items .infraction_active'))
				.toggleClass('active', infractionData.active);
		};

		let postBugStateUpdate = function(input) {
			var checkbox = input;
			var bugId = checkbox.data('bug_id');
			var value = checkbox.is(':checked') ? 1 : 0;
			var checkboxName = checkbox.attr('name');
			var container = checkbox.closest('.close_report_options ');
			var statusButtons = container.find('.fix');


			statusButtons.prop('disabled', true);
			clearInlineError(container);
			let finished = function(response) {
				statusButtons.prop('disabled', false);
				container.toggleClass('is_fixed', response.bug.fixed);
			};
			var data = {
				bug_id: bugId
			};
			data[checkboxName] = value;
			return Request.post(siteUrl + '/bugs/update_bug', data).then(function(response) {
				finished(response);
				return response;
			}, function(response) {
				finished();
				showInlineError(container, 'The bug could not be updated.');
				return response;
			});
		};
		$('.bug_description_body').on('change', 'input[type=checkbox]', function(e) {
			return postBugStateUpdate($(this));
		}).on('keyup', '#bug_description', function(e) {
			$(this).closest('.bug_description_body').addClass('changed');
		}).on('mouseenter', '.with_reply', function(e) {
			let postContent = $('.wall_post_content:first');
			postContent.data('originalMessage', postContent.val());
			postContent.val('Thanks for the report!');
		}).on('mouseleave', '.with_reply', function(e) {
			let postContent = $('.wall_post_content:first');
			if(!postContent.data('submitting')) {
				postContent.val(postContent.data('originalMessage'));
			}
		}).on('click', '.fix', function(e) {
			let button = $(this);
			let fixedInput = button.closest('.close_report_options ').find('input[name=fixed]');
			fixedInput.prop('checked', !fixedInput.prop('checked'));
			postBugStateUpdate(fixedInput).then(function(response) {

				if(response && response.success && button.hasClass('close_report')) {
					let breadcrumb = $('.page-trail');
					if(breadcrumb.length) {
						let link = breadcrumb.find('a:first');
						if(link) {
							assignPage(link.attr('href'));
						}
					}
					// history.back();
				}
			});
		});
		$('.bug_list').find('.description').siteLinker();
	}
}

if(window.bugsOpenCloseNeeded) {
	Bugs.activateDynamicBugClosing();
}



